import loader from 'src/hoc/loader'

import { actionClearData, fetchCategories } from './store'
import Categories from './Categories'

const getData = async (props, dispatch) => {
  await dispatch(fetchCategories())
}

const options = {
  onUnmount: dispatch => dispatch(actionClearData()),
}

export default loader(getData, options)(Categories)
